export class MailSettings{
    Mail: string;
    DisplayName: string;
    Password: string;
    Host: string;
    Port: string;
    EmailReceiver: string;
}